export const BINDING_SELECT_BUTTON_HEIGHT = 24;

// Styles for a span element to match the sizing of default labels of ExpressionEditor
export const labelStyle = {
  display: 'grid',
  alignItems: 'center',
  // TODO: Derive this from `theme`:
  letterSpacing: -0.2,

  // When our label is not full-width, we want to top-align the label
  // for extra-tall controls (e.g. an Asset) but also vertically
  // center the label for "standard" inputs (e.g. buttons, text
  // inputs).
  //
  // To achieve this, we top-align the label in its grid cell, but
  // also give it a fixed height that matches our standard control
  // height so it appears vertically centered.
  alignSelf: 'start',
  boxSizing: 'border-box',
  // Set padding to ensure label doesnt
  // get squished if it takes up multiple lines
  paddingTop: '6px',
  paddingBottom: '6px',
} as const;
